import * as React from "react";
import { forwardRef } from "react";
const SvgIcMonitoringCardWorks = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.6427 2L16.0483 16H17V18H3V16H3.95165L8.35724 2H11.6427ZM9.50988 5H10.4901L11.4342 8H8.56582L9.50988 5ZM7.62176 11H12.3782L13.3223 14H6.67771L7.62176 11Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgIcMonitoringCardWorks);
export { ForwardRef as ReactComponent };
